import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { CalendarOutlined } from '@ant-design/icons';
import { Typography, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ApiErrorData } from 'models/ApiResponse';
import { DashboardNew } from 'models/DashboardNew';
import { User } from 'models/User';

import { DashboardNewService } from 'services/DashboardNewService';

import Layout from '../../components/Layout/Layout';
import appI18n from '../../config/i18n';
import NewsGrid from './components/NewsGrid';

import './Home.scss';

const { Title, Text } = Typography;

const MONTHS_ES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];
const DAYS_ES = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
];

function Home() {
  const { t, i18n } = useTranslation(undefined, { i18n: appI18n });
  const [messageApi, contextHolder] = message.useMessage();
  const user: User = useSelector((state: any) => state.auth);
  const [news, setNews] = useState<DashboardNew[]>([]);
  const [loading, setLoading] = useState(true);

  const formattedDate = useMemo(() => {
    const now = new Date();
    return i18n.language === 'es'
      ? `${DAYS_ES[now.getDay()]}, ${now.getDate()} de ${
          MONTHS_ES[now.getMonth()]
        } de ${now.getFullYear()}`
      : now.toLocaleDateString('en-US', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
  }, [i18n.language]);

  useEffect(() => {
    init();
  }, []);

  const init = useCallback(async () => {
    setLoading(true);

    const response = await DashboardNewService.getTop10ByCountry(
      user.company.countryCode
    );

    if (response.success) {
      const data = response.data as DashboardNew[];
      setNews(data);
    } else {
      const error = response.data as ApiErrorData;
      messageApi.error(t('common.messages.fetch_news_error'), 3.5);
      console.error(error?.message);
    }

    setLoading(false);
  }, [user.company.countryCode, messageApi, t]);

  return (
    <Layout breadcrumbMode="none">
      {contextHolder}
      <div className="dashboard-layout-header-container">
        <Title level={4} style={{ margin: 0, lineHeight: 1.3 }}>
          {t('common.home.greeting', {
            name: user?.name || t('common.user'),
          })}
        </Title>
        <Text
          type="secondary"
          style={{
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            gap: 5,
          }}
        >
          <CalendarOutlined style={{ fontSize: 13 }} />
          {formattedDate}
        </Text>
      </div>
      <div className="home-container">
        <div className="chome-app">
          <NewsGrid loading={loading} items={news} />
        </div>
      </div>
    </Layout>
  );
}

export default Home;
